import React from 'react'

import { AccountFragment, PlanFragment, StripeSubscription } from 'src/graphql'
import { hasSystemPackage } from 'src/helpers'

import { planDetails } from '../../constants'
import PlanTile from './PlanTile'
import { style } from './pricingTableStyles'

type PlanTileGroupProps = {
  account?: AccountFragment
  addSpacer?: boolean
  plans: PlanFragment[]
  onSelect: (plan: string) => void
  currentPlan: string
  stripeSubscription?: Partial<StripeSubscription>
  getPlan: (planId: string) => PlanFragment | undefined
}

const PlanTileGroup: React.FC<PlanTileGroupProps> = props => {
  const {
    account,
    plans,
    currentPlan,
    onSelect,
    addSpacer = false,
    stripeSubscription,
    getPlan,
  } = props
  const visiblePlans = plans.filter(plan => plan.title !== 'Basic')
  return (
    <div style={{ display: 'flex' }}>
      {addSpacer && <div style={style.planSpacer} />}
      {visiblePlans.map(plan => (
        <PlanTile
          key={plan.title}
          plan={plan}
          details={planDetails.find(p => p.plan === plan.title)}
          isCurrentPlan={currentPlan === plan.id}
          onSelect={onSelect}
          containerStyle={{ minWidth: 0 }}
          hideButton={
            (currentPlan === plan.id && plan.id === '1') ||
            (currentPlan === plan.id && !!account && hasSystemPackage(account))
          }
          stripeSubscription={stripeSubscription}
          getPlan={getPlan}
        />
      ))}
    </div>
  )
}

export default PlanTileGroup
